import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'

import { Body1, Body2 } from '@ui/Typography/Typography'

import styles from './style.module.scss'

interface ModalBodyListItemProps extends PropsWithChildren {
  size?: 'body1' | 'body2'
}

interface ModalBodyListProps extends PropsWithChildren {
  noListStyle?: boolean
  ordered?: boolean
}

const ListItem: React.FC<ModalBodyListItemProps> = ({ children, size = 'body1' }) => {
  const BodyComponent = size === 'body1' ? Body1 : Body2

  return (
    <li>
      <BodyComponent color='text-med-em'>{children}</BodyComponent>
    </li>
  )
}

const List: React.FC<ModalBodyListProps> = ({ children, noListStyle, ordered }) =>
  ordered ? (
    <ol
      className={classNames(styles.list, styles.ordered, {
        [styles.noListStyle]: noListStyle,
      })}
    >
      {children}
    </ol>
  ) : (
    <ul
      className={classNames(styles.list, {
        [styles.noListStyle]: noListStyle,
      })}
    >
      {children}
    </ul>
  )

export const ModalBodyList = Object.assign(List, {
  Item: ListItem,
})
